import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/*
用途：解决html字符串显示时，内部的style无效的问题；
使用：<div [innerHTML]="htmlStr | html"></div>
* */
@Pipe({
  name: 'html',
})
export class InnerHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any, ...args: any[]): any {
    // 正则处理HTML字符串中图片宽度过大时，自适应的问题
    if (value) {
      return this.sanitizer.bypassSecurityTrustHtml(value.replace(/<img/g, "<img style='max-width: 100%;'"));
    }
  }
}
